import React, { useState, useEffect } from "react";
import { Box, Card, CardHeader, Stack, Typography, Divider } from "@material-ui/core";
import Scrollbar from "../../Scrollbar"; // Make sure to adjust this import based on your setup
import axios from "axios";
import { REST_API_END_POINT } from "src/constants/Defaultvalues"; // adjust if needed
import { useSnackbar } from "notistack";
import moment from "moment";

export default function JobCostLogsListing({ logs, setLogs, fetchJobCostLogs }) {
  return (
    <>
      <Card variant="outlined" sx={{ mt: 2, mb: 1 }}>
        <CardHeader title='Job Logs' />
        <Scrollbar sx={{ maxHeight: 400 }}>
          <Stack spacing={2} sx={{ pt: 2, pb: 2, pl: 3, pr: 3, width: { xs: 'fit-content', md: '100%' }, minWidth: 180, maxWidth: 1600, }}>
            {logs.length > 0 ? (
              logs.map((log) => (
                <Box key={log.id}>
                  <Stack direction="row" alignItems="center" spacing={2} sx={{ pb: logs.length > 1 && log !== logs[logs.length - 1] && 1.4 }}>
                    <Typography variant="body2" sx={{ whiteSpace: 'nowrap' }}>
                      {moment.unix(log.timestamp).format("MM/DD/YYYY, h:mm A")}
                    </Typography>
                    <Typography variant="body2" sx={{ textAlign: 'left', whiteSpace: 'nowrap' }}>
                      {log.message}
                    </Typography>
                  </Stack>
                  {logs.length > 1 && log !== logs[logs.length - 1] && <Divider sx={{ width: '100%', }} />}
                </Box>
              ))
            ) : (
              <Typography variant="subtitle2">No job logs available</Typography>
            )}
          </Stack>
        </Scrollbar>
      </Card>
    </>
  );
}
